import * as api from 'commons/js/api'
import Routes from 'commons/js/routes/routes'
import {
    takeLatest,
} from 'commons/js/util/promiseUtils'

export const searchVehicleInspectionStations = takeLatest((params) => {
    return api.searchVehicleInspectionStations(params)
})

export function getVehicleInspectionUrl ({ vehicleInspectionStationId, vehicleInspectionStationSlug, provinceSlug, vehicleFilter }) {
    return Routes.vehicleInspectionStationPath({
        slug: vehicleInspectionStationSlug,
        id: vehicleInspectionStationId,
        vehicle_filter: vehicleFilter,
    })
}
